export default __webpack_public_path__ + "static/media/img_seller.bac29db5.svg";